import React, { createContext, useContext, useEffect, useMemo, useState } from "react";
import { preparePreview } from "./previewImageCache";

const LANGUAGE_KEY = "aur-language";
const LanguageContext = createContext(null);

export const translations = {
  en: {
    language: "Language",
    english: "English",
    spanish: "Español",
    previous: "Previous",
    next: "Next",
    page: "Page",
    of: "of",
    back: "Back",
    home: "Home",
    about: "About",
    preview: "Preview",
    productInfo: "Product Info",
    support: "Support",
    purchase: "Purchase",
    viewBook: "View the Book",
  },
  es: {
    language: "Idioma",
    english: "English",
    spanish: "Español",
    previous: "Anterior",
    next: "Siguiente",
    page: "Página",
    of: "de",
    back: "Volver",
    home: "Inicio",
    about: "Acerca de",
    preview: "Vista previa",
    productInfo: "Información del producto",
    support: "Soporte",
    purchase: "Comprar",
    viewBook: "Ver el libro",
  },
};

export function LanguageProvider({ children }) {
  const [language, setLanguage] = useState(() => {
    const saved = window.localStorage.getItem(LANGUAGE_KEY);
    return saved === "es" ? "es" : "en";
  });

  useEffect(() => {
    window.localStorage.setItem(LANGUAGE_KEY, language);
    document.documentElement.lang = language === "es" ? "es" : "en";
  }, [language]);

  useEffect(() => {
    preparePreview(language === "es" ? "spanish" : "english");
  }, [language]);

  const value = useMemo(
    () => ({
      language,
      setLanguage,
      t: (key) => translations[language][key] || translations.en[key] || key,
    }),
    [language]
  );

  return <LanguageContext.Provider value={value}>{children}</LanguageContext.Provider>;
}

export function useLanguage() {
  const context = useContext(LanguageContext);
  if (!context) throw new Error("useLanguage must be used within LanguageProvider.");
  return context;
}